import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const recentGamesService = async () => {
  return privateRequest.get(`${ConfEnv.BASE_URL}/games/recent`);
};
